module.exports = __webpack_public_path__ + "twig-science.asset.cd698563edbe8aa1b2cf782253f30449.svg";